import { MutableRefObject } from "react";
import { MapMarkerLocation } from "../../../../features/Reports/typings/reports.types";

export function getFocusedLocation({
  focusedLocationId,
  isMapApiLoaded,
  mapRef,
  mapMarkerLocations,
  onMapReadyChange
}: {
  focusedLocationId: number | null | undefined;
  isMapApiLoaded: boolean;
  mapRef: MutableRefObject<any>;
  mapMarkerLocations: MapMarkerLocation[] | undefined;
  onMapReadyChange?: (isReady: boolean) => void;
}) {
  if (!focusedLocationId) {
    return;
  }

  if (!isMapApiLoaded || !mapRef.current || !mapMarkerLocations?.length) {
    onMapReadyChange?.(false);
    return;
  }

  const focusedLocation = mapMarkerLocations.find(
    marker => marker.locationInventoryId === focusedLocationId
  );
  const latitude = focusedLocation?.geoInformation?.[0]?.latitude;
  const longitude = focusedLocation?.geoInformation?.[0]?.longitude;

  if (latitude == null || longitude == null) {
    onMapReadyChange?.(true);
    return;
  }

  mapRef.current.panTo({ lat: latitude, lng: longitude });
  const currentZoom = mapRef.current.getZoom?.() ?? 10;
  if (currentZoom < 16) {
    mapRef.current.setZoom?.(16);
  }
  onMapReadyChange?.(true);
}

export function handleMapApiLoaded({
  focusedLocationId,
  isMapApiLoaded,
  mapMarkerLocations,
  onMapReadyChange
}: {
  focusedLocationId: number | null | undefined;
  isMapApiLoaded: boolean;
  mapMarkerLocations: MapMarkerLocation[] | undefined;
  onMapReadyChange?: (isReady: boolean) => void;
}) {
  if (focusedLocationId) {
    return;
  }

  if (!isMapApiLoaded) {
    onMapReadyChange?.(false);
    return;
  }

  onMapReadyChange?.(mapMarkerLocations !== undefined);
}
